export default {
    'form/answer/geo/select': {
        fr: 'Sélectionner un endroit',
        nl: 'Een plaats selecteren',
        en: 'Select a location',
    },
    'form/answer/geo/draw/point': {
        fr: 'Dessiner un point',
        nl: 'Een geometrie tekenen',
        en: 'Draw a point',
    },
    'form/answer/geo/draw/line-string': {
        fr: 'Dessiner une ligne',
        nl: 'Een geometrie tekenen',
        en: 'Draw a line',
    },
    'form/answer/geo/draw/polygon': {
        fr: 'Dessiner un polygône',
        nl: 'Een geometrie tekenen',
        en: 'Draw a polygon',
    },
    'form/answer/geo/draw/multi-point': {
        fr: 'Dessiner plusieurs points',
        nl: 'Een geometrie tekenen',
        en: 'Draw multiple points',
    },
    'form/answer/geo/draw/multi-line-string': {
        fr: 'Dessiner plusieurs lignes',
        nl: 'Een geometrie tekenen',
        en: 'Draw multiple lines',
    },
    'form/answer/geo/draw/multi-polygon': {
        fr: 'Dessiner plusieurs polygônes',
        nl: 'Een geometrie tekenen',
        en: 'Draw multiple polygons',
    },
    'form/answer/geo/re-select': {
        fr: 'Sélectionner un nouvel endroit',
        nl: 'Een nieuwe plaats selecteren',
        en: 'Select a new location',
    },
    'form/answer/geo/re-draw/point': {
        fr: 'Redessiner un point',
        nl: 'Een geometrie hertekenen',
        en: 'Redraw a point',
    },
    'form/answer/geo/re-draw/line-string': {
        fr: 'Redessiner une ligne',
        nl: 'Een geometrie hertekenen',
        en: 'Redraw a line',
    },
    'form/answer/geo/re-draw/polygon': {
        fr: 'Redessiner un polygône',
        nl: 'Een geometrie hertekenen',
        en: 'Redraw a polygon',
    },
    'form/answer/geo/re-draw/multi-point': {
        fr: 'Redessiner plusieurs points',
        nl: 'Een geometrie hertekenen',
        en: 'Redraw multiple points',
    },
    'form/answer/geo/re-draw/multi-line-string': {
        fr: 'Redessiner plusieurs lignes',
        nl: 'Een geometrie hertekenen',
        en: 'Redraw multiple lines',
    },
    'form/answer/geo/re-draw/multi-polygon': {
        fr: 'Redessiner plusieurs polygônes',
        nl: 'Een geometrie hertekenen',
        en: 'Redraw multiple polygons',
    },
    'form/answer/selection/user-picker': {
        fr: 'Sélectionnez une ou plusieurs réponses',
        nl: 'Selecteer een of meer antwoorden',
        en: 'Select one or more answers',
    },
    'form/answer/status/draft': {
        fr: 'Brouillon',
        nl: 'Ontwerp',
        en: 'Draft',
    },
    'form/answer/status/init': {
        fr: 'Initialisé',
        nl: 'Geïnitialiseerd',
        en: 'Initialized',
    },
    'form/answer/status/submitted': {
        fr: 'Soumise',
        nl: 'Ingediend',
        en: 'Submitted',
    },
    'form/date/min': {
        fr: 'Date de début',
        nl: 'Begindatum',
        en: 'Start date',
    },
    'form/date/max': {
        fr: 'Date de fin',
        nl: 'Einddatum',
        en: 'End date',
    },
    'form/date/helptext': {
        fr: "Sélectionner une date de début et de fin pour limiter la saisie d'une date à cet intervalle temporel",
        nl: 'Selecteer een begindatum en een einddatum om de antwoordstijdsinterval te bepalen',
        en: 'Select a start date and an end date to restrict date input to this time interval',
    },
    'form/entry/missing-type-id': {
        fr: 'Toutes les entrées doivent avoir un identifiant (id) et un type (type).',
        nl: 'Alle velden moeten een id en een type (type) hebben.',
        en: 'All entries must have an id and a type (type).',
    },
    'form/declarative/wrong-format': {
        fr: `Erreur lors de l'import de l'entrée {id} ({type}).\n
             Consultez l'aide  dans le panneau de gauche pour connaitre les champs obligatoires et leurs formats`,
        nl: `Fout bij het importeren van het veld {id} ({type}).\n
             Raadpleeg de hulp in het linkerpaneel voor de verplichte velden en hun formaten.`,
        en: `Error while parsing {type} entry {id}. Refer to the 
             help section to learn about required fields and their format.`,
    },
    'form/entry/number': { fr: 'Nombre', nl: 'Nummer', en: 'Number' },
    'form/entry/short-text': {
        fr: 'Texte court',
        nl: 'Korte tekst',
        en: 'Short text',
    },
    'form/entry/long-text': {
        fr: 'Texte long',
        nl: 'Lange tekst',
        en: 'Long text',
    },
    'form/entry/date': { fr: 'Date', nl: 'Datum', en: 'Date' },
    'form/entry/datetime': { fr: 'Nombre', nl: 'Nummer', en: 'Number' },
    'form/entry/section': { fr: 'Section', nl: 'Sectie', en: 'Section' },
    'form/entry/subsection': {
        fr: 'Sous-section',
        nl: 'Subsectie',
        en: 'Subsection',
    },
    'form/entry/selection': { fr: 'Sélection', nl: 'Keuze', en: 'Selection' },
    'form/entry/time': { fr: 'Heure', nl: 'Uur', en: 'Time' },
    'form/entry/geometry': { fr: 'Géométrie', nl: 'Geometrie', en: 'Geometry' },
    'form/entry/section-name-placeholder': {
        fr: 'Entrer le titre de la section ou sous-section',
        nl: 'De titel van de sectie of subsectie invoeren',
        en: 'Enter the section or subsection title',
    },
    'form/entry/section-description-placeholder': {
        fr: 'Décrire la section',
        nl: 'De sectie beschrijven',
        en: 'Describe the section',
    },
    'form/entry/question-name-placeholder': {
        fr: 'Entrez le titre de la question',
        nl: 'Voer de titel van de vraag in',
        en: 'Enter the question title',
    },
    'form/entry/question-description-placeholder': {
        fr: "Préciser la question pour faciliter l'encodage.",
        nl: 'Beschrijf de vraag om het antwoorden te faciliteren',
        en: 'Clarify the question to facilitate data entry.',
    },
    'form/entry/new-question': {
        fr: 'Nouvelle question',
        nl: 'Nieuwe vraag',
        en: 'New question',
    },
    'form/entry/new-section': {
        fr: 'Nouvelle section',
        nl: 'Nieuwe sectie',
        en: 'New section',
    },
    'form/entry/question-name': {
        fr: 'Titre',
        nl: 'Titel',
        en: 'Title',
    },
    'form/entry/question-description': {
        fr: "Texte d'aide à la saisie",
        nl: 'Helptekst bij het invoeren',
        en: 'Input help text',
    },
    'form/entry/section-description': {
        fr: 'Description de la section ou sous-section',
        nl: 'Beschrijving van de sectie of subsectie',
        en: 'Section or subsection description',
    },
    'form/entry/section-name': {
        fr: 'Nom',
        nl: 'Naam',
        en: 'Name',
    },
    'form/answer/date/placeholder': {
        fr: 'jour/mois/année',
        nl: 'dag/maand/jaar',
        en: 'day/month/year',
    },
    'form/entry/delete-question': {
        fr: 'Supprimer la question',
        nl: 'De vraag verwijderen',
        en: 'Delete the question',
    },
    'form/entry/edit-question': {
        fr: 'Éditer la question',
        nl: 'De vraag bewerken',
        en: 'Edit the question',
    },
    'form/entry/edit-section': {
        fr: 'Éditer la section',
        nl: 'De sectie bewerken',
        en: 'Edit the section',
    },
    'form/entry/delete-section': {
        fr: 'Supprimer la section',
        nl: 'De sectie verwijderen',
        en: 'Delete the section',
    },
    'form/not-found': {
        fr: "Erreur: Ce formulaire n'existe pas",
        nl: 'Fout: dit formulier bestaat niet',
        en: 'Error: This form does not exist',
    },
    'form/mode/declarative': {
        fr: 'Déclaratif',
        nl: 'Declaratief',
        en: 'Declarative',
    },
    'form/mode/interactive': {
        fr: 'Interactif',
        nl: 'Interactief',
        en: 'Interactive',
    },
    'form/geo/Point': {
        fr: 'Point',
        nl: 'Point',
        en: 'Point',
    },
    'form/geo/Polygon': {
        fr: 'Polygon',
        nl: 'Polygon',
        en: 'Polygon',
    },
    'form/geo/LineString': {
        fr: 'LineString',
        nl: 'LineString',
        en: 'LineString',
    },
    'form/geo/MultiPoint': {
        fr: 'MultiPoint',
        nl: 'MultiPoint',
        en: 'MultiPoint',
    },
    'form/geo/MultiPolygon': {
        fr: 'MultiPolygon',
        nl: 'MultiPolygon',
        en: 'MultiPolygon',
    },
    'form/geo/MultiLineString': {
        fr: 'MultiLineString',
        nl: 'MultiLineString',
        en: 'MultiLineString',
    },
    'form/geo/draw': {
        fr: 'Dessiner une géométrie',
        nl: 'Een geometrie tekenen',
        en: 'Draw a geometry',
    },
    'form/geo/select': {
        fr: "Sélectionner une géométrie sur base d'un référentiel",
        nl: 'Een geometrie selecteren op basis van een ruimtelijke referentie',
        en: 'Select a geometry on basis of a spatial reference system',
    },
    'form/geo/select-layer': {
        fr: 'Choisir le référentiel spatial pour la sélection',
        nl: 'Kies de ruimtelijke referentie voor de selectie',
        en: 'Choose the spatial reference for the selection',
    },
    'form/geo/select-geometry-type': {
        fr: 'Sélectionner le type de géométrie',
        nl: 'Selecteer het type geometrie',
        en: 'Select the geometry type',
    },
    'form/number/min': {
        fr: 'Valeur minimale',
        nl: 'Minimale waarde',
        en: 'Minimum value',
    },
    'form/number/max': {
        fr: 'Valeur maximale',
        nl: 'Maximale waarde',
        en: 'Maximum value',
    },
    'form/section': {
        fr: 'Section',
        nl: 'Sectie',
        en: 'Section',
    },
    'form/select/mode': {
        fr: 'Mode de sélection (une réponse unique possible ou choix multiple)',
        nl: 'Keuzemodus (één enkele antwoord of meerdere keuzes)',
        en: 'Selection mode (single answer or multiple choice)',
    },
    'form/select/ref': {
        fr: 'Choix du référentiel',
        nl: 'Referentiekeuze',
        en: 'Referential selection',
    },
    'form/select/unique': {
        fr: 'Unique',
        nl: 'Één keuze',
        en: 'Single',
    },
    'form/select/multiple': {
        fr: 'Mutiple',
        nl: 'Meerdere',
        en: 'Multiple',
    },
    'form/sub-section': {
        fr: 'Sous-section',
        nl: 'Subsectie',
        en: 'Subsection',
    },
    'form/toolbar/add-section': {
        fr: 'Ajouter une section',
        nl: 'Sectie toevoegen',
        en: 'Add a section',
    },
    'form/toolbar/add-sub-section-entry': {
        fr: 'Ajouter une sous-section',
        nl: 'Subsectie toevoegen',
        en: 'Add a subsection',
    },
    'form/toolbar/add-selection-entry': {
        fr: 'Ajouter une question de type "Sélection"',
        nl: 'Een vraag van het type "Keuze" toevoegen',
        en: 'Add a "Selection" question',
    },
    'form/toolbar/add-string-entry': {
        fr: 'Ajouter une question de type "Texte court"',
        nl: 'Een vraag van het type "Korte tekst" toevoegen',
        en: 'Add a "Short text" question',
    },
    'form/toolbar/add-text-entry': {
        fr: 'Ajouter une question de type "Texte long"',
        nl: 'Een vraag van het type "Lange tekst" toevoegen',
        en: 'Add a "Long text" question',
    },
    'form/toolbar/add-question': {
        fr: 'Ajouter une question',
        nl: 'Een vraag toevoegen',
        en: 'Add a question',
    },
    'form/toolbar/add-number-entry': {
        fr: 'Ajouter une question de type "Nombre"',
        nl: 'Een vraag van het type "Nummer" toevoegen',
        en: 'Add a "Number" question',
    },
    'form/toolbar/add-date-entry': {
        fr: 'Ajouter une question de type "Date"',
        nl: 'Een vraag van het type "Datum" toevoegen',
        en: 'Add a "Date" question',
    },
    'form/toolbar/add-geo-entry': {
        fr: 'Ajouter une question de type "Geo"',
        nl: 'Een vraag van het type "Geo" toevoegen',
        en: 'Add a "Geo" question',
    },
    'form/missing-referential': {
        fr: "L'identifiant ne correspond à aucun référentiel",
        nl: 'Deze id komt niet overeen met een referentie',
        en: 'The id does not match any referential',
    },
    'form/preview': {
        fr: 'Prévisualisation',
        nl: 'Voorvertoning',
        en: 'Preview',
    },
    'form/preview/condition/help': {
        fr: 'Cette entrée est affichée si :',
        nl: 'Dit veld wordt weergegeven als:',
        en: 'This entry is displayed if:',
    },
    'form/preview/condition/has-answer': {
        fr: 'la question «{question}» a une réponse',
        nl: 'vraag «{question}» heeft een antwoord',
        en: 'question «{question}» has been answered',
    },
    'form/preview/condition/has-no-answer': {
        fr: "la question «{question}» n'a pas de réponse",
        nl: 'vraag «{question}» heeft geen antwoord',
        en: 'question «{question}» has not been answered',
    },
    'form/preview/condition/equals': {
        fr: 'la réponse à la question «{question}» est égale à {value}',
        nl: 'het antwoord op vraag «{question}» is gelijk aan {value}',
        en: 'the answer to question «{question}» is equal to {value}',
    },
    'form/preview/condition/different': {
        fr: 'la réponse à la question «{question}» est différente de {value}',
        nl: 'het antwoord op vraag «{question}» is verschillend van {value}',
        en: 'the answer to question «{question}» is different from {value}',
    },
    'form/preview/condition/greater-than': {
        fr: 'la réponse à la question «{question}» est supérieure à {value}',
        nl: 'het antwoord op vraag «{question}» is groter dan {value}',
        en: 'the answer to question «{question}» is greater than {value}',
    },
    'form/preview/condition/lower-than': {
        fr: 'la réponse à la question «{question}» est inférieure à {value}',
        nl: 'het antwoord op vraag «{question}» is kleiner dan {value}',
        en: 'the answer to question «{question}» is less than {value}',
    },
    'form/preview/condition/greater-than-or-equal': {
        fr: 'la réponse à la question «{question}» est supérieure ou égale à {value}',
        nl: 'het antwoord op vraag «{question}» is groter dan of gelijk aan {value}',
        en: 'the answer to question «{question}» is greater than or equal to {value}',
    },
    'form/preview/condition/lower-than-or-equal': {
        fr: 'la réponse à la question «{question}» est inférieure ou égale à {value}',
        nl: 'het antwoord op vraag «{question}» is kleiner dan of gelijk aan {value}',
        en: 'the answer to question «{question}» is less than or equal to {value}',
    },
    'form/preview/condition/contains': {
        fr: 'la réponse à la question «{question}» contient {value}',
        nl: 'het antwoord op vraag «{question}» bevat {value}',
        en: 'the answer to question «{question}» contains {value}',
    },
    'form/preview/condition/does-not-contain': {
        fr: 'la réponse à la question «{question}» ne contient pas {value}',
        nl: 'het antwoord op vraag «{question}» bevat {value} niet',
        en: 'the answer to question «{question}» does not contain {value}',
    },
    'form/preview/condition/when-all': {
        fr: 'toutes les conditions suivantes sont remplies :',
        nl: 'aan alle volgende voorwaarden is voldaan:',
        en: 'all of the following conditions are met:',
    },
    'form/preview/condition/when-some': {
        fr: 'au moins une des conditions suivantes est remplie :',
        nl: 'aan minstens één van de volgende voorwaarden is voldaan:',
        en: 'at least one of the following conditions is met:',
    },
    'form/preview/input/required': {
        fr: 'La réponse est requise',
        nl: 'Antwoord verplicht',
        en: 'Answer is required',
    },
    'form/preview/unique': {
        fr: 'Mode : unique',
        nl: 'Modus: één keuze',
        en: 'Mode: single',
    },
    'form/preview/multiple': {
        fr: 'Mode : multiple',
        nl: 'Modus: meerdere',
        en: 'Mode: multiple',
    },
    'form/preview/referential-name': {
        fr: 'Référentiel: ',
        nl: 'Data referentie:',
        en: 'Referential',
    },
    'form/preview/selection-element': {
        fr: 'Éléments: ',
        nl: 'Items',
        en: 'Items',
    },
    'form/preview/geometry-basemap': {
        fr: 'Fond de plan: ',
        nl: 'Achtergrond',
        en: 'Basemap',
    },
    'form/preview/geometry-draw': {
        fr: 'Mode dessin',
        nl: 'Een geometrie tekenen',
        en: 'Draw mode',
    },
    'form/preview/geometry-metadata': {
        fr: 'Métadonnée: ',
        nl: 'Metadata:',
        en: 'Metadata:',
    },
    'form/preview/geometry-type': {
        fr: 'Type de géométrie: ',
        nl: 'Type geometrie:',
        en: 'Geometry type:',
    },
    'form/preview/geometry-selection': {
        fr: 'Mode sélection',
        nl: 'Selectiemodus',
        en: 'Selection mode',
    },
    'form/preview/condition/entry-not-found': {
        fr: "La question ciblée par la condition n'existe pas.",
        nl: 'De vraag die door de conditie wordt bedoeld, bestaat niet.',
        en: 'The question targeted by the condition does not exist.',
    },
    'form/preview/condition/referential-not-found': {
        fr: "La condition sur le référentiel n'est pas bien configurée.",
        nl: 'De conditie op de referentie is niet correct geconfigureerd.',
        en: 'The condition on the referential is not properly configured.',
    },
    'form/composition/help': {
        fr: 'Aide',
        nl: 'Hulp',
        en: 'Help',
    },
    'form/composition/help/copy-snippet': {
        fr: "Copier l'exemple",
        nl: 'Voorbeeld kopiëren',
        en: 'Copy the example',
    },
    'form/composition/help/copied-snippet': {
        fr: 'Exemple copié !',
        nl: 'Voorbeeld gekopieerd!',
        en: 'Example copied!',
    },
    'form/composition/text-input-placeholder': {
        fr: 'Définissez ici le formulaire avec le langage csform...',
        nl: 'Schrijf hier de formulier met de csform structuur',
        en: 'Define the form in its structured way',
    },
    'form/composition/help/colon': {
        fr: `Pour utiliser le charactère ":" dans les labels et dans les descriptions, veuillez entourer le label de guillemets.
Un exemple est disponible dans la partie "sous-section".
`,
        nl: `Om het teken ":" in labels en beschrijvingen te gebruiken, moet u het label tussen aanhalingstekens plaatsen.
Een voorbeeld vindt u in het gedeelte "subsectie".`,
        en: `To use the ":" character in labels and descriptions, please enclose the label in quotation marks.
An example is available in the "sub-section" section.`,
    },
    'form/composition/help/description': {
        fr: `Composition des questions à l'aide de balises fonctionnelles. Veiller à ne pas laisser de balises sans contenu.`,
        nl: `Samenstelling van vragen met behulp van functionele tags. Zorg ervoor dat er geen tags zonder inhoud achterblijven.`,
        en: `Compose questions using functional tags. Be careful not to leave tags without content.`,
    },
    'form/composition/help/chapter/structure': {
        fr: 'Structure',
        nl: 'Structuur',
        en: 'Structure',
    },
    'form/composition/help/chapter/questions': {
        fr: 'Questions',
        nl: 'Vragen',
        en: 'Questions',
    },
    'form/composition/help/chapter/behaviors': {
        fr: 'Comportements',
        nl: 'Gedragen',
        en: 'Behaviors',
    },
    'form/composition/help/chapter/behaviors-introduction': {
        fr: `
Il est possible de conditionner la visibilité d’une question 
en fonction des réponses à d’autres questions. Ces conditions 
sont encodées sous le mot-clé \`when\`  avec deux éléments. 

D’une part la référence à une question par son identifiant, 
et d’autre part la qualité de réponse sous la forme de l’association 
d’une condition concrète et d’une valeur. 

De plus, sous les mot-clés \`when-all\` et  \`when-some\`, 
il est possible d’encoder une **liste** de conditions. 
La validité du bloc sera alors décidée si respectivement, 
*toutes* ou *au moins une* conditions sont remplies.

Suit la liste des conditions concrètes disponibles.

`,
        nl: `
Het is mogelijk om de zichtbaarheid van een vraag afhankelijk te maken van de antwoorden op andere vragen. Deze voorwaarden worden gecodeerd onder het trefwoord \`when\` met twee elementen. Enerzijds de verwijzing naar een vraag via zijn identificatiecode, en anderzijds de kwaliteit van het antwoord in de vorm van de combinatie van een concrete voorwaarde en een waarde. 

Bovendien is het mogelijk om onder de trefwoorden \`when-all\` en \`when-some\` een **lijst** met voorwaarden te coderen. De geldigheid van het blok wordt dan bepaald als respectievelijk *alle* of *ten minste één* voorwaarde is vervuld. 
        
Hieronder volgt de lijst met concrete voorwaarden.
`,
        en: `
It is possible to condition the visibility of a question based on the answers to other questions. These conditions are encoded under the keyword \`when\` with two elements. On the one hand, the reference to a question by its identifier, and on the other hand, the quality of the answer in the form of the association of a concrete condition and a value. 

In addition, under the keywords \`when-all\` and \`when-some\`, it is possible to encode a **list** of conditions. The validity of the block will then be determined if *all* or *at least one* of the conditions are met, respectively. 
        
The following is a list of the specific conditions available.
`,
    },
    'form/composition/help/condition/has-answer/name': {
        fr: 'Présence d’une réponse',
        nl: 'Aanwezigheid van een antwoord',
        en: 'Answered',
    },
    'form/composition/help/condition/has-answer/explanation': {
        fr: 'Affiche une entrée en fonction de la présence d’une réponse.',
        nl: 'Geeft een invoer weer op basis van de aanwezigheid van een antwoord.',
        en: 'Displays an entry if a another question has been answered.',
    },
    'form/composition/help/condition/equals/name': {
        fr: 'Égalité',
        nl: 'Gelijkheid',
        en: 'Equality',
    },
    'form/composition/help/condition/equals/explanation': {
        fr: 'Affiche une entrée si la réponse à une question est égale à une valeur donnée.',
        nl: 'Toont een veld als het antwoord op een vraag gelijk is aan een bepaalde waarde.',
        en: 'Displays an entry if the answer to a question equals a given value.',
    },
    'form/composition/help/condition/different/name': {
        fr: 'Différence',
        nl: 'Verschil',
        en: 'Difference',
    },
    'form/composition/help/condition/different/explanation': {
        fr: "Affiche une entrée si la réponse à une question est différente d'une valeur donnée.",
        nl: 'Toont een veld als het antwoord op een vraag verschilt van een bepaalde waarde.',
        en: 'Displays an entry if the answer to a question differs from a given value.',
    },
    'form/composition/help/condition/greater-than/name': {
        fr: 'Supérieure',
        nl: 'Groter',
        en: 'Greater',
    },
    'form/composition/help/condition/greater-than/explanation': {
        fr: 'Affiche une entrée si la réponse à une question est supérieure à une valeur donnée.',
        nl: 'Toont een veld als het antwoord op een vraag groter is dan een bepaalde waarde.',
        en: 'Displays an entry if the answer to a question is greater than a given value.',
    },
    'form/composition/help/condition/lower-than/name': {
        fr: 'Inférieure',
        nl: 'Kleiner',
        en: 'Lower',
    },
    'form/composition/help/condition/lower-than/explanation': {
        fr: 'Affiche une entrée si la réponse à une question est inférieure à une valeur donnée.',
        nl: 'Toont een veld als het antwoord op een vraag kleiner is dan een bepaalde waarde.',
        en: 'Displays an entry if the answer to a question is lower than a given value.',
    },
    'form/composition/help/condition/greater-than-or-equal/name': {
        fr: 'Supérieure ou égale',
        nl: 'Groter of gelijk',
        en: 'Greater or equal',
    },
    'form/composition/help/condition/greater-than-or-equal/explanation': {
        fr: 'Affiche une entrée si la réponse à une question est supérieure ou égale à une valeur donnée.',
        nl: 'Toont een veld als het antwoord op een vraag groter dan of gelijk is aan een bepaalde waarde.',
        en: 'Displays an entry if the answer to a question is greater than or equal to a given value.',
    },
    'form/composition/help/condition/lower-than-or-equal/name': {
        fr: 'Inférieure ou égale',
        nl: 'Kleiner of gelijk',
        en: 'Lower or equal',
    },
    'form/composition/help/condition/lower-than-or-equal/explanation': {
        fr: 'Affiche une entrée si la réponse à une question est inférieure ou égale à une valeur donnée.',
        nl: 'Toont een veld als het antwoord op een vraag kleiner dan of gelijk is aan een bepaalde waarde.',
        en: 'Displays an entry if the answer to a question is lower than or equal to a given value.',
    },
    'form/composition/help/condition/contains/name': {
        fr: 'Contient',
        nl: 'Bevat',
        en: 'Contains',
    },
    'form/composition/help/condition/contains/explanation': {
        fr: 'Affiche une entrée si la réponse à une question à choix multiple contient une valeur donnée.',
        nl: 'Toont een veld als het antwoord op een meerkeuzegestuurd vraag een bepaalde waarde bevat.',
        en: 'Displays an entry if the answer to a multiple-choice question contains a given value.',
    },
    'form/composition/help/condition/does-not-contain/name': {
        fr: 'Ne contient pas',
        nl: 'Bevat niet',
        en: 'Does not contain',
    },
    'form/composition/help/condition/does-not-contain/explanation': {
        fr: 'Affiche une entrée si la réponse à une question à choix multiple ne contient pas une valeur donnée.',
        nl: 'Toont een veld als het antwoord op een meerkeuzegestuurd vraag een bepaalde waarde niet bevat.',
        en: 'Displays an entry if the answer to a multiple-choice question does not contain a given value.',
    },
    'form/condition/invalid-operator/list-on-unique': {
        fr: "L'entrée «{id}» utilise l'opérateur «{op}» sur la question «{question}» qui est à réponse unique. Cet opérateur ne s'applique qu'aux questions à réponse multiple.",
        nl: 'Veld «{id}» gebruikt operator «{op}» op vraag «{question}» die slechts één antwoord toestaat. Deze operator is alleen geldig voor meerkeuzesvragen.',
        en: 'Entry «{id}» uses operator «{op}» on question «{question}» which allows a single answer. This operator only applies to multiple-choice questions.',
    },
    'form/condition/invalid-operator/binary-on-multiple': {
        fr: "L'entrée «{id}» utilise l'opérateur «{op}» sur la question «{question}» qui est à réponse multiple. Utilisez «contains» ou «does-not-contain» pour les questions à réponse multiple.",
        nl: 'Veld «{id}» gebruikt operator «{op}» op vraag «{question}» die meerdere antwoorden toestaat. Gebruik «contains» of «does-not-contain» voor meerkeuzesvragen.',
        en: 'Entry «{id}» uses operator «{op}» on question «{question}» which allows multiple answers. Use «contains» or «does-not-contain» for multiple-choice questions.',
    },
    'form/composition/help/condition/variable-number-of-question/name': {
        fr: 'Nombre variable de questions',
        nl: 'Variabel aantal vragen',
        en: 'Variable number of questions',
    },
    'form/composition/help/condition/variable-number-of-question/explanation': {
        fr: `Pour afficher un nombre variable de questions selon la réponse à une question number, utilisez la propriété when avec greater-than-or-equal sur chaque question conditionnelle. La première question collecte la valeur numérique et chaque question suivante définit un seuil d'affichage correspondant à sa position. Ainsi, exactement autant de questions que la valeur saisie seront affichées.`,
        nl: `Om een variabel aantal vragen weer te geven, afhankelijk van het antwoord op een vraagnummer, gebruikt u de eigenschap wanneer groter dan of gelijk op elke voorwaardelijke vraag. De eerste vraag verzamelt de numerieke waarde en elke volgende vraag definieert een weergavedrempel die overeenkomt met de positie ervan. Op deze manier worden precies evenveel vragen als de ingevoerde waarde weergegeven.`,
        en: `To display a variable number of questions depending on the answer to a question number, use the when property with greater-than-or-equal on each conditional question. The first question collects the numerical value, and each subsequent question defines a display threshold corresponding to its position. This way, exactly as many questions as the entered value will be displayed.`,
    },
    'form/composition/help/condition/when-all/name': {
        fr: 'Toutes les conditions',
        nl: 'Alle voorwaarden',
        en: 'All conditions',
    },
    'form/composition/help/condition/when-all/explanation': {
        fr: 'Affiche une entrée si toutes les conditions listées sont remplies.',
        nl: 'Toont een veld als aan alle vermelde voorwaarden is voldaan.',
        en: 'Displays an entry if all listed conditions are met.',
    },
    'form/composition/help/condition/when-some/name': {
        fr: 'Au moins une condition',
        nl: 'Minstens één voorwaarde',
        en: 'At least one condition',
    },
    'form/composition/help/condition/when-some/explanation': {
        fr: 'Affiche une entrée si au moins une des conditions listées est remplie.',
        nl: 'Toont een veld als aan minstens één van de vermelde voorwaarden is voldaan.',
        en: 'Displays an entry if at least one of the listed conditions is met.',
    },
    'form/composition/help/section/name': {
        fr: 'Nouvelle section',
        nl: 'Nieuwe sectie',
        en: 'New section',
    },
    'form/composition/help/subsection/name': {
        fr: 'Nouvelle sous-section',
        nl: 'Nieuwe subsectie',
        en: 'New subsection',
    },
    'form/composition/help/short-text/name': {
        fr: 'Question de type texte court',
        nl: 'Vraag van het type korte tekst',
        en: 'Short text question',
    },
    'form/composition/help/long-text/name': {
        fr: 'Question de type texte long',
        nl: 'Vraag van het type lange tekst',
        en: 'Long text question',
    },
    'form/composition/help/number/name': {
        fr: 'Question de type nombre',
        nl: 'Vraag van het type nummer',
        en: 'Number question',
    },
    'form/composition/help/selection/name': {
        fr: 'Question de type sélection',
        nl: 'Vraag van het type keuze',
        en: 'Selection question',
    },
    'form/composition/help/date/name': {
        fr: 'Question de type date',
        nl: 'Vraag van het type datum',
        en: 'Date question',
    },
    'form/composition/help/geo/name': {
        fr: 'Question de type géographique',
        nl: 'Vraag van het type geografisch',
        en: 'Geographic question',
    },
    'form/composition/help/section/explanation': {
        fr: 'Une section du formulaire',
        nl: 'Een formuliersectie',
        en: 'A form section',
    },
    'form/composition/help/subsection/explanation': {
        fr: 'Une sous-section du formulaire',
        nl: 'Een formuliersubsectie',
        en: 'A form subsection',
    },
    'form/composition/help/short-text/explanation': {
        fr: 'À utiliser pour des questions où une réponse textuelle courte est attendue.',
        nl: 'Te gebruiken voor vragen waarop een kort tekstantwoord wordt verwacht.',
        en: 'To be used for questions where a short text answer is expected.',
    },
    'form/composition/help/long-text/explanation': {
        fr: 'À utiliser pour des questions qui demandent un long texte.',
        nl: 'Te gebruiken voor vragen die een lang tekstantwoord vereisen.',
        en: 'To be used for questions that require a long text answer.',
    },
    'form/composition/help/number/explanation': {
        fr: 'À utiliser pour les champs numériques',
        nl: 'Te gebruiken voor numerieke velden.',
        en: 'To be used for numeric fields.',
    },
    'form/composition/help/selection/explanation': {
        fr: 'À utiliser pour les choix multiples, ou cases à cocher',
        nl: 'Te gebruiken voor meerkeuzevragen of selectievakjes.',
        en: 'To be used for multiple choice questions or checkboxes.',
    },
    'form/composition/help/date/explanation': {
        fr: 'Pour les champs date.',
        nl: 'Voor datumvelden.',
        en: 'For date inputs',
    },
    'form/composition/help/geo/draw/explanation': {
        fr: "Pour le dessin d'un point, ligne ou polygone",
        nl: 'Om een punt, een lijn of een polygoon te tekenen',
        en: 'For drawing a point, line or polygon',
    },
    'form/composition/help/geo/draw/title': {
        fr: 'Dessin',
        nl: 'Tekenen',
        en: 'Draw',
    },
    'form/composition/help/geo/explanation': {
        fr: 'Pour les questions liées à des données spatiales.',
        nl: 'Voor vragen met betrekking tot ruimtelijke gegevens.',
        en: 'For questions related to spatial data.',
    },
    'form/composition/help/geo/select/explanation': {
        fr: "Sélection sur base d'un référentiel spatial",
        nl: 'Selectie op basis van een ruimtelijke referentie',
        en: 'Selection based on a spatial referential',
    },
    'form/composition/help/geo/select/title': {
        fr: 'Sélection',
        nl: 'Selectie',
        en: 'Selection',
    },
    'form/composition/help/validate': {
        fr: 'Valider',
        nl: 'Bevestigen',
        en: 'Confirm',
    },
    'form/composition/help/cancel': {
        fr: 'Annuler',
        nl: 'Annuleren',
        en: 'Cancel',
    },
    'form/composition/help/remove': {
        fr: 'Supprimer',
        nl: 'Verwijderen',
        en: 'Delete',
    },
    'form/composition/help/uploading': {
        fr: 'Téléversement en cours',
        nl: 'Bezig met uploaden',
        en: 'Uploading',
    },
    'form/composition/help/change': {
        fr: 'Modifier',
        nl: 'Wijzigen',
        en: 'Edit',
    },
    'form/composition/help/add': {
        fr: 'Ajouter un document',
        nl: 'Een document toevoegen',
        en: 'Add a document',
    },
    'form/composition/help/components': {
        fr: 'Identifiants de ce formulaire',
        nl: 'ids van dit formulier',
        en: 'ids of this form',
    },
    'form/composition/help/components/description': {
        fr: 'Les identifiants ou `id` sont des clés pour faire référence à une question, une réponse spécifique ou à un référentiel. Utilisez ces identifiants pour configurer une condition ou faire le lien avec un référentiel.',
        nl: "ids of `id`'s zijn sleutels om te verwijzen naar een vraag, een specifiek antwoord of een referentie. Gebruik deze ids om een voorwaarde in te stellen of een koppeling met een referentie te maken.",
        en: "ids or `id`'s are keys used to reference a question, a specific answer, or a referential. Use these ids to configure a condition or link to a referential.",
    },
    'form/composition/help/referentials': {
        fr: 'Référentiels',
        nl: 'Referenties',
        en: 'Referentials',
    },
    'form/composition/help/entries': {
        fr: 'Questions',
        nl: 'Vragen',
        en: 'Questions',
    },
    'form/form-status': {
        fr: 'Statut de publication',
        nl: 'Publicatiestatus',
        en: 'Publication status',
    },
    'form/form-status-draft': {
        fr: 'Brouillon',
        nl: 'Ontwerp',
        en: 'Draft',
    },
    'form/form-status-shared': {
        fr: 'Test',
        nl: 'Test',
        en: 'Test',
    },
    'form/form-status-published': {
        fr: 'Publié',
        nl: 'Gepubliceerd',
        en: 'Published',
    },
    'form/form-status-closed': {
        fr: 'Cloturé',
        nl: 'Afgesloten',
        en: 'Closed',
    },
    'form/missing-title': {
        fr: 'Titre manquant',
        nl: 'Ontbrekende titel',
        en: 'Missing title',
    },
    'form/validation/number_too_low': {
        fr: 'La valeur est trop petite, la valeur minimale acceptée est {min_value}',
        nl: 'De waarde is te klein, de minimaal toegestane waarde is {min_value}',
        en: 'The value is too small, the minimum accepted value is {min_value}',
    },
    'form/validation/number_too_high': {
        fr: 'La valeur est trop grande, la valeur maximale acceptée est {max_value}',
        nl: 'De waarde is te groot, de maximaal toegestane waarde is {max_value}',
        en: 'The value is too large, the maximum accepted value is {max_value}',
    },
    'form/validation/is_required': {
        fr: "Ce champ est requis et n'a pas été répondu",
        nl: 'Dit veld is verplicht en is niet ingevuld.',
        en: 'This field is required and has not been answered',
    },
    'form/validation/date_too_early': {
        fr: 'La date doit être postérieure au {min_value, date, ::yyyyMMddHHmm}',
        nl: 'De datum moet later zijn dan {min_value, date, ::yyyyMMddHHmm}',
        en: 'The date must be after {min_value, date, ::yyyyMMddHHmm}',
    },
    'form/validation/date_too_late': {
        fr: 'La date doit être antérieure au {max_value, date, ::yyyyMMddHHmm}',
        nl: 'De datum moet vóór {max_value, date, ::yyyyMMddHHmm} liggen',
        en: 'The date must be before {max_value, date, ::yyyyMMddHHmm}',
    },
    'form/validation/filesize_too_big': {
        fr: 'La taille du fichier est trop importante. La taille maximale est {max_size}Mo.',
        nl: 'Het bestand is te groot. De maximale grootte is {max_size} MB.',
        en: 'The file size is too large. The maximum size is {max_size}MB.',
    },
    'form/referentials/title': {
        fr: 'Référentiels',
        nl: 'Referenties',
        en: 'Referentials',
    },
    'form/referentials/description': {
        fr: 'Sélectionner les données de référence utilisées dans le formulaire',
        nl: 'Selecteer de referentiegegevens die in het formulier worden gebruikt.',
        en: 'Select the reference data used in the form',
    },
    'form/referentials/available': {
        fr: 'Référentiels disponibles',
        nl: 'Beschikbare referenties',
        en: 'Available referentials',
    },
    'form/referentials/selected': {
        fr: 'Référentiels sélectionnés',
        nl: 'Geselecteerde referenties',
        en: 'Selected referentials',
    },
    'form/referentials/remove': {
        fr: 'Retirer le référentiel du formulaire',
        nl: 'De referentie uit het formulier verwijderen',
        en: 'Remove the referential from the form',
    },
    'form/composer/duplicate-entry': {
        fr: 'Plusieurs entrées de ce formulaire ont le même identifiant. Veuillez vous assurer que chaque entrée comporte un identifiant unique dans le formulaire.',
        nl: 'Meerdere velden in dit formulier hebben dezelfde id. Zorg ervoor dat elk veld een unieke id heeft binnen het formulier.',
        en: 'This form contains multiple entries with the same id. Please make sure every entry has a unique id in the form.',
    },
    'form/has-submitted-answers-and-cannot-edit': {
        fr: "Au moins une réponse a été soumise à ce formulaire, l'édition du formulaire n'est plus autorisée.",
        nl: 'Er is minstens één antwoord ingediend voor dit formulier. Het bewerken van het formulier is niet meer toegestaan.',
        en: 'At least one answer has been submitted to this form, editing the form is no longer allowed.',
    },
    'form/has-pending-answers-warn-and-delete': {
        fr: "Ce formulaire est en test. Des réponses vides ont été créées. Pour continuer l'édition du formulaire, supprimez-les.",
        nl: 'Dit formulier is in test. Er zijn lege antwoorden. Verwijder ze om het formulier verder te bewerken.',
        en: 'This form can be tested. There are some empty answers for this form. Delete them to edit the form.',
    },
    'form/confirm-delete-form': {
        fr: 'Êtes-vous sûr de vouloir supprimer ce formulaire ?',
        nl: 'Bent u zeker dat u dit formulier wilt verwijderen?',
        en: 'Are you sure you want to delete this form?',
    },
    'form/confirm-delete-entry': {
        fr: 'Êtes-vous sûr de vouloir supprimer cette entrée du formulaire ?',
        nl: 'Bent u zeker dat u dit veld uit het formulier wilt verwijderen?',
        en: 'Are you sure you want to delete this form entry?',
    },
    'form/composer/filter-available-referentials': {
        fr: 'Chercher parmi les référentiels disponibles',
        nl: 'Zoeken in de beschikbare referenties',
        en: 'Search among available referentials',
    },
    'form/dashboard/explanation': {
        fr: "Cette application permet aux gestionnaires de composer des formulaires, d'une part, et de faire leur suivi. ",
        nl: 'Met deze applicatie kunnen managers formulieren opstellen en deze vervolgens opvolgen.',
        en: 'An application for form creation and monitoring.',
    },
};
